import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { createLink } from '@tanstack/react-router';

import { Button } from '../../button';

const LinkButton = createLink(Button);

const NotFoundIcon = () => {
  const theme = useTheme();
  return (
    <svg
      width='121'
      height='121'
      viewBox='0 0 121 121'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3135_96622)'>
        <path
          d='M118.5 16.4999V104.5C118.5 108.917 114.918 112.5 110.5 112.5H10.5C6.0825 112.5 2.5 108.917 2.5 104.5V16.4999C2.5 12.0824 6.0825 8.49988 10.5 8.49988H110.5C114.918 8.49988 118.5 12.0824 118.5 16.4999Z'
          fill={theme.palette.primary[50]}
        />
        <path
          d='M118.5 16.4999V18.4999H20.5C16.165 18.4999 12.635 21.9474 12.505 26.2499C12.4987 26.4584 12.4993 73.2076 12.4998 94.5311C12.5 101.046 2.5 101.378 2.5 94.4999V16.4999C2.5 12.0816 6.08175 8.49988 10.5 8.49988H110.5C114.918 8.49988 118.5 12.0816 118.5 16.4999Z'
          fill={theme.palette.secondary[50]}
        />
        <path
          d='M118.5 16.4999V26.2499H2.5V16.4999C2.5 12.0824 6.0825 8.49988 10.5 8.49988H110.5C114.918 8.49988 118.5 12.0824 118.5 16.4999Z'
          fill={theme.palette.secondary[100]}
        />
        <path
          d='M103.03 18.4999H20.5C16.165 18.4999 12.635 21.9474 12.505 26.2499H2.5V16.4999C2.5 12.0816 6.08175 8.49988 10.5 8.49988H103C109.876 8.49988 109.548 18.4999 103.03 18.4999Z'
          fill={theme.palette.primary[50]}
        />
        <path
          d='M118.5 28.2499H17.5C16.3955 28.2499 15.5 27.3544 15.5 26.2499C15.5 25.1454 16.3955 24.2499 17.5 24.2499H116.5V16.4999C116.5 13.1917 113.808 10.4999 110.5 10.4999H10.5C7.19175 10.4999 4.5 13.1917 4.5 16.4999V104.5C4.5 107.808 7.19175 110.5 10.5 110.5H110.5C113.808 110.5 116.5 107.808 116.5 104.5V40.3332C116.5 39.2287 117.396 38.3332 118.5 38.3332C119.604 38.3332 120.5 39.2287 120.5 40.3332V104.5C120.5 110.014 116.014 114.5 110.5 114.5H10.5C4.986 114.5 0.5 110.014 0.5 104.5V16.4999C0.5 10.9859 4.986 6.49991 10.5 6.49991H110.5C116.014 6.49991 120.5 10.9859 120.5 16.4999V26.2499C120.5 27.3544 119.604 28.2499 118.5 28.2499ZM17.5 19.4999H18.5C19.6045 19.4999 20.5 18.6044 20.5 17.4999C20.5 16.3954 19.6045 15.4999 18.5 15.4999H17.5C16.3955 15.4999 15.5 16.3954 15.5 17.4999C15.5 18.6044 16.3955 19.4999 17.5 19.4999ZM31 19.4999C32.1045 19.4999 33 18.6044 33 17.4999C33 16.3954 32.1045 15.4999 31 15.4999H30C28.8955 15.4999 28 16.3954 28 17.4999C28 18.6044 28.8955 19.4999 30 19.4999H31ZM43.5 19.4999C44.6045 19.4999 45.5 18.6044 45.5 17.4999C45.5 16.3954 44.6045 15.4999 43.5 15.4999H42.5C41.3955 15.4999 40.5 16.3954 40.5 17.4999C40.5 18.6044 41.3955 19.4999 42.5 19.4999H43.5ZM53.1875 80.2499C52.083 80.2499 51.1875 79.3544 51.1875 78.2499V52.2499C51.1875 51.1454 52.083 50.2499 53.1875 50.2499H67.8125C68.917 50.2499 69.8125 51.1454 69.8125 52.2499V78.2499C69.8125 79.3544 68.917 80.2499 67.8125 80.2499H53.1875ZM55.1875 76.2499H65.8125V54.2499H55.1875V76.2499ZM32.7557 50.3982C31.733 49.9812 30.5658 50.4717 30.1483 51.4942L22.0233 71.4004C21.487 72.7144 22.4552 74.1562 23.875 74.1562H36.5V78.2499C36.5 79.3544 37.3955 80.2499 38.5 80.2499C39.6045 80.2499 40.5 79.3544 40.5 78.2499V74.1562H42.5625C43.667 74.1562 44.5625 73.2607 44.5625 72.1562C44.5625 71.0517 43.667 70.1562 42.5625 70.1562H40.5V52.2499C40.5 51.1454 39.6045 50.2499 38.5 50.2499C37.3955 50.2499 36.5 51.1454 36.5 52.2499V70.1562H26.8515L33.8515 53.0057C34.2693 51.9832 33.7785 50.8157 32.7557 50.3982ZM93.0625 80.2499C94.167 80.2499 95.0625 79.3544 95.0625 78.2499V74.1562H97.125C98.2295 74.1562 99.125 73.2607 99.125 72.1562C99.125 71.0517 98.2295 70.1562 97.125 70.1562H95.0625V52.2499C95.0625 51.1454 94.167 50.2499 93.0625 50.2499C91.958 50.2499 91.0625 51.1454 91.0625 52.2499V70.1562H81.414L88.4143 53.0057C88.8315 51.9829 88.341 50.8154 87.3183 50.3979C86.2952 49.9809 85.128 50.4714 84.7105 51.4939L76.5855 71.4002C76.0493 72.7144 77.0175 74.1559 78.4372 74.1559H91.0622V78.2499C91.0625 79.3544 91.958 80.2499 93.0625 80.2499ZM85.5 94.7499C84.3955 94.7499 83.5 95.6454 83.5 96.7499C83.5 97.8544 84.3955 98.7499 85.5 98.7499H88.25C89.3545 98.7499 90.25 97.8544 90.25 96.7499C90.25 95.6454 89.3545 94.7499 88.25 94.7499H85.5ZM32.75 98.7499H75.5625C76.667 98.7499 77.5625 97.8544 77.5625 96.7499C77.5625 95.6454 76.667 94.7499 75.5625 94.7499H32.75C31.6455 94.7499 30.75 95.6454 30.75 96.7499C30.75 97.8544 31.6455 98.7499 32.75 98.7499Z'
          fill={theme.palette.primary[600]}
        />
      </g>
      <defs>
        <clipPath id='clip0_3135_96622'>
          <rect
            width='120'
            height='120'
            fill='white'
            transform='translate(0.5 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const NotFound404 = () => {
  return (
    <Stack
      alignItems='center'
      justifyContent='center'
      width='100%'
      height='100dvh'
      gap={2.5}
    >
      <Box>
        <NotFoundIcon />
      </Box>

      <Box textAlign='center'>
        <Typography variant='h6' component='h1' color='text.primary'>
          Page not found
        </Typography>
        <Typography variant='body2' pt={0.75}>
          Uh-oh. The page you&apos;re looking for couldn&apos;t be found.
        </Typography>
      </Box>
      <LinkButton to='/'>Return to Dashboard</LinkButton>
    </Stack>
  );
};

export default NotFound404;
